import getAllTypes from 'utils/loads/methods/getAllTypes';
import getMaximumOfLoads from 'utils/loads/methods/getMaximumOfLoads';

export default {
  getAllTypes,
  getMaximumOfLoads,
};
